module.exports = __webpack_public_path__ + "static/media/PE.a9d5f411.svg";